import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import SaveIcon from '@mui/icons-material/Save';

import {LOOK_OVERLAYS} from "../../core/constants";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import WithSavePostMessage from "../../hocs/withSavePostMessage";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {isIframe} from "../../../../misc/helpers";

const GroheSaveButton = (props) => {

  const {intl, setLookOverlayOpened, topButtonClick, userIsLoggedIn, fabricatorData} = props;

  if (fabricatorData.isGrohe) {
    return null
  }

  const isLixil = isIframe() && fabricatorData.isLixil;

  const wishlistButtonClick = (savePostMessage) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsSave);
    if (userIsLoggedIn) {
      savePostMessage();
    } else {
      setLookOverlayOpened(isLixil ? LOOK_OVERLAYS.questionLogin : LOOK_OVERLAYS.leadCapture);
    }
    topButtonClick();
  }

  const disabled = false;
  const buttonText = isLixil ? "tooltip.wishlist" : "tooltip.save";

  return (
    <WithSavePostMessage>
      {(savePostMessage) => (
        <div className={"gm-buttons__button"}>
          <IconButton aria-label={intl.formatMessage({id: buttonText})}
                      disabled={disabled}
                      data-id="save-button"
                      className="look-icon look-icon--small1 look-icon--grohe"
                      onClick={() => wishlistButtonClick(savePostMessage)}>
            <SaveIcon/>
          </IconButton>
        </div>
      )}
    </WithSavePostMessage>
  )
};

GroheSaveButton.propTypes = {
  topButtonClick: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {userIsLoggedIn} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    userIsLoggedIn,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheSaveButton)
)
